import Menu from "app/menu/menu";

export default Menu;
